import React, { useRef, useState, useEffect } from 'react';
import './Teaser.css';
import { API_BASE_URL } from '../../utils';
import { FaPlay, FaPause } from 'react-icons/fa';

const url = `${API_BASE_URL}/master/assets/uploads/`;

export default React.memo(function Teaser({ teasers = [] }) {
  const videoRefs = useRef([]);
  const [userInteracted, setUserInteracted] = useState(false);
  const [playingStates, setPlayingStates] = useState({});
  const [selectedCategory, setSelectedCategory] = useState('All');

  // Generate categories
  const categories = ['All', ...new Set(teasers.map((item) => item.title))];

  // Count teasers per category
  const imageCountByCategory = categories.reduce((acc, category) => {
    if (category === 'All') {
      acc[category] = teasers.length;
    } else {
      acc[category] = teasers.filter((item) => item.title === category).length;
    }
    return acc;
  }, {});

  // Filtered teaser list
  const filteredTeasers =
    selectedCategory === 'All'
      ? teasers
      : teasers.filter((item) => item.title === selectedCategory);

  // Detect user interaction for autoplay with sound
  useEffect(() => {
    const handleInteraction = () => {
      setUserInteracted(true);
      document.removeEventListener('click', handleInteraction);
    };
    document.addEventListener('click', handleInteraction);
    return () => document.removeEventListener('click', handleInteraction);
  }, []);

  const handleMouseEnter = (index) => {
    const video = videoRefs.current[index];
    if (video && userInteracted) {
      video.muted = false;
      if (video.readyState >= 2) {
        video.play().catch(console.warn);
      } else {
        video.oncanplay = () => {
          video.play().catch(console.warn);
          video.oncanplay = null;
        };
      }
    }
  };

  const handleMouseLeave = (index) => {
    const video = videoRefs.current[index];
    if (video) {
      video.pause();
      video.muted = true;
    }
  };

  return (
    <div className="vclp-teaser-empty-container">
      <h1 className="vclp-teaser-title-heading title-of-section">Teasers</h1>

      {teasers.length === 0 ? (
        <div className="vclp-teaser-empty-no-container">
          <div className="vclp-teaser-empty-content">
            <h1>Teasers Coming Soon</h1>
            <p>We’re working on exciting teasers. Stay tuned!</p>
            <img
              src="https://illustrations.popsy.co/gray/web-design.svg"
              alt="Coming Soon"
              className="vclp-teaser-empty-image"
            />
          </div>
        </div>
      ) : (
        <>
          <div className="vcdp-package-container-section-with-filter">
            {/* <div className="vcdp-gallery-filters">
              {categories.map((cat, i) => (
                <span
                  key={i}
                  className={`vcdp-filter-button ${selectedCategory === cat ? 'vcdp-active' : ''}`}
                  onClick={() => setSelectedCategory(cat)}
                >
                  {cat}
                </span>
              ))}
            </div> */}

            <div className="vclp-teaser-container">
              {filteredTeasers.map((teaser, index) => (
                <React.Fragment key={index}>
                  <a
                    data-fancybox="teasers"
                    data-caption={teaser.title}
                    data-type="inline"
                    href={`#teaser-video-${index}`}
                  >
                    <div className="vclp-teaser-item">
                      {/* <h2 className="vclp-teaser-title">{teaser.title}</h2> */}
                      <div
                        className="vclp-teaser-video-wrapper"
                        onMouseEnter={() => handleMouseEnter(index)}
                        onMouseLeave={() => handleMouseLeave(index)}
                      >
                        <video
                          ref={(el) => (videoRefs.current[index] = el)}
                          className="vclp-teaser-video"
                          src={`${url}${teaser.video}`}
                          muted
                          loop
                          playsInline
                          preload="auto"
                          style={{ objectFit: 'cover', width: '100%', height: '100%', backgroundColor: '#000' }}
                          onPlay={() =>
                            setPlayingStates((prev) => ({ ...prev, [index]: true }))
                          }
                          onPause={() =>
                            setPlayingStates((prev) => ({ ...prev, [index]: false }))
                          }
                        />
                        <button className="vclp-play-button">
                          {playingStates[index] ? <FaPause size={16} /> : <FaPlay size={16} />}
                        </button>
                      </div>
                    </div>
                  </a>

                  {/* Fancybox Preview */}
                  <div style={{ display: 'none' }}>
                    <div
                      id={`teaser-video-${index}`}
                      style={{
                        height: '90vh',
                        width: 'auto',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        overflow: 'hidden',
                        backgroundColor: 'white',
                      }}
                    >
                      <video
                        src={`${url}${teaser.video}`}
                        controls
                        playsInline
                        style={{
                          maxHeight: '100%',
                          maxWidth: '100%',
                          objectFit: 'contain',
                        }}
                      />
                    </div>
                  </div>
                </React.Fragment>
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
});
